// export const BACKEND_HOST = 'http://127.0.0.1:8000/'
export const BACKEND_HOST = "https://freelancer-dgnm.onrender.com"

export const USERS_BACKEND_URL = `${BACKEND_HOST}/users/auth/`;
export const PROJECT_BACKEND_URL = `${BACKEND_HOST}/project/`;
export const USERS_LIST_URL = `${BACKEND_HOST}/users/`;

